import { LOAD_CART, ADD_PRODUCT, REMOVE_PRODUCT } from "./actionTypes";

const initialState = {
    products: []
};

export default function(state = initialState, action) {
    switch (action.type) {
        case LOAD_CART:
            console.log("going load cart: ");
            return {
                ...state,
                products: action.payload
            };
        case ADD_PRODUCT:
            console.log("add product action");
            return {
                ...state,
                productToAdd: Object.assign({}, action.payload)
            };
        case REMOVE_PRODUCT:
            console.log("remove product");
            return {
                ...state,
                productToRemove: Object.assign({}, action.payload)
            };
        default:
            return state;
    }
}
